const renderBrandedFooterRow = () => {
    const elements = document.getElementsByClassName("ds-branded-footer-row");

    if (elements.length > 0) {
        for (let i = 0; i < elements.length; i++) {
            let new_div = document.createElement("div");
            new_div.innerHTML = `
            <center>
            <div class="fod-full-width-container fod-center">
            <small>
            <a target="_blank" href="https://tradepending.com/">Website Service Experience Platform</a><br><a href="https://www.tradepending.com" rel="noopener" target="_blank"><img alt="TadePending" src="https://s3.amazonaws.com/snap-images.tradepending.com/tp-logos/greycolor-horizontal-small.jpg" /></a>
            </small>
            </div>
            </center>
            `;
            elements[i].appendChild(new_div);
        }
    }
};

if (process.env.REACT_APP_ENVIRONMENT !== "local") renderBrandedFooterRow();
window.renderShareModal = renderBrandedFooterRow;

export default renderBrandedFooterRow;
